import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, Button, Dropdown } from 'semantic-ui-react';
import Link from '../../../../lib/components/link';
import { MenuItemType } from '../../../../lib/proptypes/menu.proptypes';
import classes from './desktopHeader.css';

const myHuddleButton = () => (
  <Button className={classes.myhuddleButton}>
    myHUDDLE <Icon fitted name="angle down" className={classes.angleIcon} />
  </Button>
);

const myHuddleDropDown = ({ menu }) => (
  <Dropdown trigger={myHuddleButton()} icon={null}>
    <Dropdown.Menu className={classes.myHuddleMenu}>
      {menu.map(
        item => {
          var testLabels = ['Custom Leagues', 'Player Tracking', 'Account Information', 'Subscription Status', 'Email Preferences'];
          item.action = undefined;
          item.isExternal = true;
          switch(item.label) {
            case 'Custom Leagues':
              item.url = '/myhuddle/custom';
              break;
            case 'Player Tracking':
              item.url = '/myhuddle/player-tracking';
              break;
            case 'Player Search':
              item.url = '/myhuddle/nfl-player-search';
              break;
            case 'Account Information':
              item.url = '/myhuddle/account-information';
              break;
            case 'Change Password':
              item.url = '/myhuddle/change-password';
              break;
            case 'Subscription Status':
              item.url = '/myhuddle/subscription-status';
              break;
            case 'Sign Out':
              item.url = '/logout';
              break;
            case 'Email Preferences':
              item.url = '/myhuddle/email';
              break;
            default:
              item.url = '/myHuddle/';
          }
          return (item.action || item.url) &&
          <Dropdown.Item key={item.key} className={classes.myHuddleDropDownItem}>
            <Link className={classes.myHuddleLink} {...item} />
          </Dropdown.Item>;
        }

      )}
    </Dropdown.Menu>
  </Dropdown>
);

myHuddleDropDown.propTypes = {
  menu: PropTypes.arrayOf(MenuItemType).isRequired,
};

const mapStateToProps = state => ({
  menu: state.nav.header,
});

export default connect(mapStateToProps)(myHuddleDropDown);



// WEBPACK FOOTER //
// ./src/app/components/Header/DesktopHeader/MyHuddleDropdown.js